// frontend/src/utils/legalVersions.js
//
// The legal-document versions a sign-up surface displays, sent with every
// account-creation request so the backend can record WHICH version the user
// accepted (table `terms_acceptances`, backend/app/services/terms_acceptance.py).
//
// Source: data/legal/legal-versions.json - a small file of its own so the
// sign-up bundle (the register page and the homepage conversion popup) never
// imports the full legal texts. The backend test tests/test_terms_acceptance.py
// pins it equal to the backend constants AND to the "last updated" date of
// terms-of-use.json / privacy-policy.json: a terms change fails CI until both
// version copies are bumped.
//
// Dependency-free (no services import), so it keeps working when a page test
// mocks services/auth.

import LEGAL_VERSIONS from "../data/legal/legal-versions.json";

/**
 * The request fields both sign-up doors send: the email register body (built
 * in hooks/useSignupDoors.js) and the Google register-mode body (built in
 * services/auth.js loginWithGoogle). Never sent on a login.
 *
 * @returns {{terms_version: string, privacy_policy_version: string}}
 */
export function signupLegalVersionFields() {
  return {
    terms_version: LEGAL_VERSIONS.terms_of_use,
    privacy_policy_version: LEGAL_VERSIONS.privacy_policy,
  };
}
